export enum SignInScreenState {
  INCORRECT_PHONE = "incorrect_phone",
}
